export const PAGE_WIDTH = 928;
